import { ApplicationEnum, DriveEventActionEnum, DriveEventSubActionEnum } from '@workalizer/shared';
import { format } from 'date-fns';
var demoUser = function (id, name, email) { return ({
    id: id,
    name: name,
    email: email,
    avatar: null
}); };
export var documentTimeline = function (input) {
    var baseDate = input.dateFrom
        ? format(new Date(input.dateFrom), 'yyyy-MM-dd')
        : '2024-01-15';
    return {
        items: [
            {
                id: 1,
                type: ApplicationEnum.DRIVE,
                action: DriveEventActionEnum.DOCUMENT_CREATE,
                subAction: null,
                title: 'Created by John Smith',
                startDate: "".concat(baseDate, "T08:20:00.000Z"),
                endDate: null,
                orgUnitTitle: 'Finance',
                users: [demoUser(1, 'Anna Kowalska', 'anna@example.com')]
            },
            {
                id: 2,
                type: ApplicationEnum.DRIVE,
                action: DriveEventActionEnum.DOCUMENT_PRINT,
                subAction: null,
                title: 'Print by Piotr Zielinski',
                startDate: "".concat(baseDate, "T08:48:00.000Z"),
                endDate: null,
                orgUnitTitle: 'Ops',
                users: [demoUser(2, 'Piotr Zielinski', 'piotr@example.com')]
            },
            {
                id: 3,
                type: ApplicationEnum.DRIVE,
                action: DriveEventActionEnum.DOCUMENT_APPROVAL_REQUESTED,
                subAction: null,
                title: 'Approval Requested by Ewa Wisniewska',
                startDate: "".concat(baseDate, "T09:03:00.000Z"),
                endDate: null,
                orgUnitTitle: 'HR',
                users: [demoUser(3, 'Ewa Wisniewska', 'ewa@example.com')]
            },
            {
                id: 4,
                type: ApplicationEnum.DRIVE,
                action: DriveEventActionEnum.DOCUMENT_SHARE,
                subAction: DriveEventSubActionEnum.DOCUMENT_SHARED_EXTERNALLY,
                title: 'Shared Externally by Anna Kowalska',
                startDate: "".concat(baseDate, "T10:55:00.000Z"),
                endDate: null,
                orgUnitTitle: 'Finance',
                users: [demoUser(1, 'Anna Kowalska', 'anna@example.com')]
            },
            {
                id: 5,
                type: ApplicationEnum.DRIVE,
                action: DriveEventActionEnum.DOCUMENT_RENAME,
                subAction: null,
                title: 'Rename by Michael Brown',
                startDate: "".concat(baseDate, "T11:10:00.000Z"),
                endDate: null,
                orgUnitTitle: 'Legal',
                users: [demoUser(4, 'Michael Brown', 'michael@example.com')]
            },
            {
                id: 6,
                type: ApplicationEnum.DRIVE,
                action: DriveEventActionEnum.DOCUMENT_VIEW,
                subAction: null,
                title: 'Viewed by John Smith',
                startDate: "".concat(baseDate, "T11:42:00.000Z"),
                endDate: null,
                orgUnitTitle: 'Product',
                users: [demoUser(5, 'John Smith', 'john@example.com')]
            }
        ]
    };
};
